import client from './client';

export const importInventoryItems = (data) =>
  client.post('/bulk-import/items', data).then((r) => r.data);

export const getBulkImportsPaginated = (params) =>
  client.get('/bulk-import', { params }).then((r) => r.data);

export const getBulkImport = (uuid) =>
  client.get(`/bulk-import/${uuid}`).then((r) => r.data);
